define('modules/companion/main',["jQuery", "T1", "T1Module"], function ($, T1, T1Module) {
  return new T1Module({
    name: "companion",
    viewCfgs: {
      list: {}
    },
    defaultView: "list"
  });
});
